<div *ngIf="successMessage" class="alert alert-success" role="alert">
    <mat-icon>thumb_up</mat-icon> &nbsp;
    <label style="vertical-align: text-bottom; margin-bottom: 0rem;">
        {{successMessage}}
    </label>
</div>

<div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    <label style="vertical-align: text-bottom; margin-bottom: 0rem;">
        {{errorMessage}}
    </label>
</div>

<div class="row_1">
    <div class="top_grid_agg">
        <label class="fylabel">Fiscal Year</label> &nbsp; &nbsp;
        <span class="content">
            <select class="drpdwn_fiscalyear" [(ngModel)]="fiscalYearChosen" (change)="display()">
                <option value="" selected> --- </option>
                <option *ngFor="let fiscalYear of fiscalYears" [value]="fiscalYear.fiscalYear">
                    {{fiscalYear.fiscalYear}}
                </option>
            </select>
            <button *ngIf="enableGrid" mat-raised-button class="add-railpoint" style="display: inline;" (click)="addRailPoint()" title="Add Rail Point">
                ADD
            </button>
            <button *ngIf="enableGrid" mat-raised-button class="refresh-btn" style="display: inline;" (click)="refreshData()">
                REFRESH
            </button>
        </span>

        <div class="grid-agg" *ngIf="enableGrid">
            <ag-grid-angular #agGrid [ngStyle]="{'height': dynamicHeight + 'px',
                    'width':'100%' }" id="myGrid" class="ag-theme-balham" [pagination]="setPagination"
                [columnDefs]="columnDefs" [rowData]="rowData" [icons]="icons" [defaultColDef]="defaultColDef"
                [suppressCellSelection]="true" [paginationPageSize]="paginationPageSize"[theme]="'legacy'"
                (gridReady)="onGridReady($event)" (window:resize)="sizeToFit()" [context]="context"
                [enableCellTextSelection]="true" [ensureDomOrder]="true">
            </ag-grid-angular>

            <div class="custom-pagination" *ngIf="totalRecords > 0">
                <div class="left">
                    <span class="records-per-page">
                        <span>Records/Page : </span>
                        <select [(ngModel)]="rpPage" (change)="rppChanged($event)">
                            <option *ngFor="let size of pgDropDown" [value]="size.value">{{ size.value }}</option>
                        </select>
                    </span>
                </div>
                <div class="right">
                    <span class="viewing-records">
                    <span class="w-600">{{sRecord}}</span> to <span class="w-600">{{eRecord}}</span> of <span class="w-600">{{totalRecords}}</span>
                    <button (click)="goToFirstPage()" [disabled]="getCurrentPage() === true"><i class="fa-solid fa-backward-fast"
                        [ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    <button (click)="goToPreviousPage()" [disabled]="getCurrentPage() === true"><i class="fa-solid fa-backward-step"
                        [ngStyle]="getCurrentPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    <span>Page <span class="w-600">{{cPage}}</span> of <span class="w-600">{{tPage}}</span></span>
                    <button (click)="goToNextPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-step"
                        [ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    <button (click)="goToLastPage()" [disabled]="isLastPage() === true"><i class="fa-solid fa-forward-fast"
                        [ngStyle]="isLastPage() === true ? {'color': 'gray'} : {'color': '#1394f6'}"></i></button>
                    </span>
                </div>
            </div>
        </div>
    </div>
</div>